var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copilot-tc-result",class:{
    'e-w-full': !_vm.isMediaResult,
  }},[(_vm.isMediaResult)?_c('CopilotToolCallResultMediaClip',_vm._b({attrs:{"media-clip":_vm.mediaClip,"cameras-by-exid":_vm.camerasByExid,"with-refresh":_vm.withRefresh}},'CopilotToolCallResultMediaClip',_vm.$attrs,false)):(_vm.isChartResult)?_c('CopilotChart',{attrs:{"options":_vm.chartData,"user":_vm.user,"project":_vm.project,"with-export-btn":_vm.withExportChartBtn}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }